export const NEW_BATCH_LABEL = 'New';

/**
 * A batch's label, or a fallback that never renders empty.
 *
 * HC2 assigns the batch number only after REQUESTED, and `batch_label` is
 * composed as `"{preference_group} - {NN}"` at that point — so a fresh batch
 * has a blank label until the number lands. The fallback shows the bare group
 * name, the same bare-group shape the backend's `batch_display_label()` uses
 * while no number is known. The backend additionally normalises a trailing
 * "Batch" and returns empty when the group is missing, so `"New"` here is a
 * UI-only guard against an empty cell. Once the number arrives the stored
 * label wins unchanged. Never synthesise a number: a placeholder `01` reads
 * as a real HC2 batch and misleads compliance staff.
 */
export function formatBatchLabel(
  batchLabel: string | null | undefined,
  preferenceGroup: string | null | undefined
): string {
  const label = batchLabel?.trim();
  if (label) {
    return label;
  }
  return preferenceGroup?.trim() || NEW_BATCH_LABEL;
}
